export default __webpack_public_path__ + "static/media/i_wdt_c_1.172156ac.mp3";